'use client';
import { useTheme } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ReactNode, useMemo } from 'react';

import { useHeaderHeight } from '@/lib/hooks/useHeaderHeight';
import { getTypographyModifierClasses } from '@/theme';

type MainProps = {
  children: ReactNode;
  className?: string;
  hideChrome?: boolean;
  overlayHeader?: boolean;
};

export default function Main({
  children,
  className,
  hideChrome = false,
  overlayHeader = false,
}: MainProps) {
  const theme = useTheme();
  const headerHeight = useHeaderHeight();
  const buildId = useMemo(() => {
    const id = process.env.NEXT_PUBLIC_BUILD_ID;
    return typeof id === 'string' && id ? `Bd${id}`.substring(0, 8) : '';
  }, []);

  return (
    <>
      <GlobalStyles
        styles={() => ({
          body: {
            color: theme.palette.text.primary,
            ...getTypographyModifierClasses(theme),
          },
        })}
      />
      {/* Spacer to account for fixed header */}
      {!hideChrome && !overlayHeader && <div style={{ height: headerHeight }} />}
      <main
        className={`page-content-main ${className}`}
        data-bid={buildId}
        style={{
          width: '100%',
          maxWidth: '100%',
        }}
      >
        {children}
      </main>
    </>
  );
}
